import { render, staticRenderFns } from "./AllocationCharts.vue?vue&type=template&id=18153c19&lang=pug"
import script from "./AllocationCharts.vue?vue&type=script&lang=js"
export * from "./AllocationCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports